import { call, put, all, takeLatest } from 'redux-saga/effects';
import programService from 'services/program';
import {
  adminDashboardProgramsApi,
  PROGRAM_DASHBOARD_TAG,
} from 'services/apiSlices/programs/adminDashboardProgramsApi';
import { adminDashboardApi, DASHBOARD_TOTALS_TAG } from 'services/apiSlices/adminDashboardApi';
import actions from './actions';
import types from './types';

// Program Setup edits land through this saga, but the admin dashboard's program
// cards read from separate RTK Query slices with their own cache.
function* invalidateAdminDashboardCache() {
  yield put(adminDashboardProgramsApi.util.invalidateTags([PROGRAM_DASHBOARD_TAG]));
  yield put(adminDashboardApi.util.invalidateTags([DASHBOARD_TOTALS_TAG]));
}

export function* fetchProgramManagementProgram(action) {
  const { id } = action.payload;
  try {
    const program = yield call(programService.fetchProgramManagementProgram, {
      id,
    });
    yield put(actions.fetchProgramManagementProgramSucceeded(program.data));
  } catch (e) {
    yield put(actions.fetchProgramManagementProgramFailed({ message: e.message }));
  }
}

export function* updateProgramManagementProgram(action) {
  const { callback, payload } = action;
  try {
    const update = yield call(programService.updateProgramManagementProgram, payload);
    yield put(
      actions.updateProgramManagementProgramSucceeded({
        ...update.data,
        ids: payload.ids,
      })
    );
    yield call(invalidateAdminDashboardCache);
    if (callback) yield call(callback);
  } catch (e) {
    yield put(
      actions.updateProgramManagementProgramFailed({
        message: (e.response && e.response.data) || e.message,
      })
    );
  }
}

export function* uploadProgramFile(action) {
  const { id, ...programPicture } = action.payload;
  try {
    const response = yield call(programService.uploadProgramFile, {
      id,
      ...programPicture,
    });
    yield put(actions.updateProgramManagementProgramSucceeded(response.data));
    yield call(invalidateAdminDashboardCache);
  } catch (e) {
    yield put(actions.updateProgramManagementProgramFailed({ message: e.message }));
  }
}

function* programSaga() {
  yield all([
    takeLatest(types.PROGRAM_MANAGEMENT_FETCH_PROGRAM, fetchProgramManagementProgram),
    takeLatest(types.PROGRAM_MANAGEMENT_UPDATE_PROGRAM, updateProgramManagementProgram),
    takeLatest(types.PROGRAM_MANAGEMENT_UPLOAD_IMAGE, uploadProgramFile),
  ]);
}

export default programSaga;
